import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Main from './Bill/Main';
import Form from './Bill/Form';

// Utils
import {
  getDataWithComp,
  getMaxDocNo,
  getAlert,
  getClearLocalStorage
} from '../../../utils/SamuiUtils';

import { getReport } from '../../../utils/ReportUtils';

const Bill = () => {
  const [mode, setMode] = useState('');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [maxBiNo, setMaxBiNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      await getClearLocalStorage();
      setMode('S');
      fetchRealtime();
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp('API_1301_BL_H', `ORDER BY Doc_No DESC`);
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }

      // หาค่าสูงของ DocNo ใน BL_H สำหรับ BI (ใบวางบิล)
      const maxBi = getMaxDocNo(masterList, 'BI');
      setMaxBiNo(maxBi);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onPageInsert = () => {
    setMode('I')
  };

  const onPageUpdate = (docNo) => {
    setMaxBiNo(docNo);
    setMode('U')
  };

  return (
    <div>
      <div className="Invoice">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === 'S' ? (
                  <Main
                    name={'ใบวางบิล'}
                    dataMasterList={dataMasterList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(docNo) => onPageUpdate(docNo)}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    setMode={setMode}
                    name={'ใบวางบิล'}
                    docNo={maxBiNo}
                    getReport={getReport}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bill;